import type { OHLCVPoint } from '../../api/types';
import type { ChartSeries } from '../../event/chart/seriesTypes';

export type PriceMode = 'line' | 'candles';

export const PRICE_SERIES_ID = 'price';

export function priceSeries(
    points: readonly OHLCVPoint[],
    label: string,
    color: string,
    mode: PriceMode
): ChartSeries {
    const base = {
        id: PRICE_SERIES_ID,
        label,
        color,
        unit: 'price' as const,
        axis: 'shared' as const,
        home: 'probability' as const,
        movable: false,
        hasData: points.length > 0,
    };
    if (mode === 'candles') {
        return {
            ...base,
            draw: 'candles',
            data: {
                kind: 'candles',
                candles: points.map(p => ({
                    t: p.t.getTime(),
                    open: p.open,
                    high: p.high,
                    low: p.low,
                    close: p.close,
                })),
            },
        };
    }
    return {
        ...base,
        draw: 'line',
        data: {
            kind: 'points',
            points: points.map(p => ({ t: p.t.getTime(), v: p.close })),
        },
    };
}
